/**
 * @generated SignedSource<<f903e445b23be710a30b67fa33a21419>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersExpertPerspectiveArticle$data = {
  readonly types: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly entityId: string;
    } | null | undefined> | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "helpersExpertPerspectiveArticle";
};
export type helpersExpertPerspectiveArticle$key = {
  readonly " $data"?: helpersExpertPerspectiveArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersExpertPerspectiveArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersExpertPerspectiveArticle"
};

(node as any).hash = "10577456c4fe83a22b73efd31b043066";

export default node;
